// src/components/ActiveSwarmCard/SwarmCardHeader.js

import React from 'react';
import PropTypes from 'prop-types';
import { IconButton, Chip, CircularProgress } from '@mui/material';
import PlayCircleFilledIcon from '@mui/icons-material/PlayCircleFilled';
import StopCircleIcon from '@mui/icons-material/StopCircle';

import editIcon from '../../../../../../img/pencil-icon.svg';
import { STN_FE_URL } from '../../../../../../constants';
import { useEditSwarmMutation } from '../../../../../../services/swarmsApi';

function StartSwarmButton({ onClick }) {
  return (
    <IconButton 
        aria-label="play-swarm" 
        color='success'
        sx={{ 
          margin: 0,
          padding: 0,
          marginBottom: '8px'
        }}
        onClick={(e) => { onClick(e); }}
      >
        <PlayCircleFilledIcon />
      </IconButton>
  );
}

function StopSwarmButton({ onClick }) {
  return (
    <IconButton 
        aria-label="play-swarm" 
        color='error'
        sx={{ 
          margin: 0,
          padding: 0,
          marginBottom: '8px'
        }}
        onClick={(e) => { onClick(e); }}
      >
        <StopCircleIcon />
      </IconButton>
  );
}

/**
 * SwarmCardHeader Component
 * Displays the status, type, and play icon of the swarm.
 * 
 * @param {Object} props
 * @param {boolean} props.running - Indicates if the swarm is running.
 * @param {number|string} props.bteId - The bteId of the event to construct the link.
 * @returns {JSX.Element}
 */
const SwarmCardHeader = ({ running, bteId, onEdit, handleStartSwarmClick, handleStopSwarmClick, editSwarmIsLoading }) => {
  
  // Construct the URL
  const eventURL = `${STN_FE_URL}#/events-details/${bteId}`;

  function onStartSwarmClick(e) {
    console.log('Start button clicked for swarm ID');
    handleStartSwarmClick(e);
  }

  function onStopSwarmClick(e) {
    console.log('Stop button clicked for swarm ID');
    handleStopSwarmClick(e);
  }

  return (
    <div style={{ 
      display: 'flex', 
      flexDirection: 'column', 
      justifyContent: 'space-between', 
      alignItems: 'center', 
      margin: '0',
      padding: '0', 
      width: '34px',
      height: '100%' 
    }}>

      {
        editSwarmIsLoading ?
          <CircularProgress size={24} sx={{ color: "primary", alignSelf: 'center' }} /> :
          running ?
          <StopSwarmButton onClick={onStopSwarmClick} /> :
          <StartSwarmButton onClick={onStartSwarmClick} />
      }
      
      
      {/* Swarm Status Chip as a Link */}
      <Chip
        label="StN"
        component="a"
        href={eventURL}
        target="_blank" rel="noreferrer"
        rel="noopener noreferrer"
        clickable
        sx={{
          width: "26px",
          height: '20px',
          fontSize: '10px',
          backgroundColor: '#2980B9',
          color: '#FFFFFF',
          fontWeight: 'bolder',
          borderRadius: '4px',
          textDecoration: 'none',
          marginTop: '4px',
          marginBottom: '4px',
          '.MuiChip-label': {
            padding: 0,
          },
        }}
      />

      {/* Edit Button */}
      <IconButton
        aria-label="edit-swarm"
        sx={{ padding: 0, margin: "0 0 0.1em 0" }}
        onClick={(e) => { e.stopPropagation(); onEdit(); }}
      >
        <img
          src={editIcon}
          alt='edit icon'
          height="18px" width="18px"
        />
      </IconButton>
    </div>
  );
};

SwarmCardHeader.propTypes = {
  onEdit: PropTypes.func.isRequired,
  isNow: PropTypes.bool.isRequired,
  running: PropTypes.bool.isRequired,
  primaryColor: PropTypes.string.isRequired,
  bteId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
};

export default SwarmCardHeader;
